import { blackShadow } from '../../colors';

export default {
	disabled: {
		color: blackShadow,
	},
};
